import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth-service.service';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-account-lock-redirect',
  template: '<div></div>',
  styles: []
})
export class AccountLockRedirectComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private userService: UserService
  ) { }

  ngOnInit(): void {

    this.userService.lock().subscribe({
      next: () => {

        const googleSiteUrl = (environment as any).RedirectSiteUrlWhenLock;


        this.authService.logout(googleSiteUrl || '/login');
      },
      error: (error) => {
        console.error('Error locking account:', error);
        this.authService.logout('/login');
      }
    });
  }
}
